export var ALL_GROUPS = '@/ALL_GROUPS';
